import React, { ReactElement, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import useForceUpdate from "use-force-update";
//import { number, object } from "yup";
import { Application } from "../";
import { InputErrorMessage } from "../../ui";
import { ApplicationDropzone } from "../ApplicationDropzone";

interface IProps {
	application: Application;
	jumpToStep?: any;
	nextStep: number;
}

export const StepGovernmentId = (props: IProps): ReactElement => {
	const [errors, setErrors] = useState(null);

	if (props.application.currentStep < 4) {
		props.application.currentStep = 4;
	}

	const forceUpdate = useForceUpdate();

	const application = props.application;

	const uploadedAttachements = application.attachmentsForPrefix("govt-id");

	const validateStep = () => {
		props.jumpToStep(props.nextStep);
		// const schemaOptions = {
		// 	hasUploadedId: number().min(
		// 		1,
		// 		"Please upload your Government Issued ID.",
		// 	),
		// };

		// const schemaObject = {
		// 	hasUploadedId: uploadedAttachements.length,
		// };
		// const schema = object(schemaOptions);
		// schema
		// 	.validate(schemaObject, { abortEarly: false })
		// 	.then(valid => {
		// 		if (valid) {
		// 			setErrors(null);
		// 			props.jumpToStep(props.nextStep);
		// 		}
		// 	})
		// 	.catch(err => {
		// 		setErrors(err);
		// 	});
	};

	return (
		<>
			<Row className="mb-4">
				<Col>
					<h5 className="mt-3 mb-3">Government Issued ID</h5>
					<ApplicationDropzone
						application={props.application}
						fileIdentifier="govt-id"
						onUploadComplete={() => {
							setErrors(null);
							forceUpdate();
						}}
					/>
					<p className="help mt-2">
						A Government Issued ID of the participant(s) is required
						to complete the application. The ID can be provided at a
						later time.
					</p>
					<InputErrorMessage errors={errors} field="hasUploadedId" />
				</Col>
				<Col sm={12} className="pt-4">
					{uploadedAttachements.length ? (
						<>
							<strong>Uploaded Files</strong>
							<ul>
								{uploadedAttachements.map((attachment, idx) => {
									return (
										<li key={idx}>{attachment.filename}</li>
									);
								})}
							</ul>
						</>
					) : null}
				</Col>
			</Row>
			<Row>
				<Col>
					<Button
						variant="primary"
						size="lg"
						className="pull-left btn-next"
						onClick={() => props.jumpToStep(props.nextStep - 2)}
					>
						Previous
					</Button>
					<Button
						variant="primary"
						size="lg"
						className="float-right btn-next"
						onClick={validateStep}
					>
						Next
					</Button>
				</Col>
			</Row>
		</>
	);
};
